import { TinyApiClient, TinyApiTransport } from "@tiny/api";
import { authStorage } from "@tiny/utils";

/**
 * TinyAlbert's transport for the shared @tiny/api client. Points at the Albert
 * API gateway (same `/customerservice/...` paths as email, resolved by the
 * client's built-in preparePath) and injects the einstein access token.
 */
const transport: TinyApiTransport = {
  baseUrl: import.meta.env.VITE_APP_API_URL || "",
  getToken: () => authStorage.getAccessToken() ?? null,
};

export const tinyApiClient = new TinyApiClient(transport);
